import {InfoOutlined} from '@mui/icons-material';
import {Box, Divider, IconButton, Tooltip, Typography} from '@mui/material';

interface SectionProps {
    title: string;
    children: React.ReactNode;
    tooltip?: string;
}

const Section = ({title, children, tooltip}: SectionProps) => (
    <Box sx={{mb: 3.5}}>
        <Box sx={{display: 'flex', alignItems: 'center', gap: 0.5, mb: 1}}>
            <Typography
                variant='overline'
                sx={{
                    color: 'text.disabled',
                    letterSpacing: '0.08em',
                }}
            >
                {title}
            </Typography>
            {tooltip && (
                <Tooltip
                    title={
                        <span style={{whiteSpace: 'pre-line'}}>{tooltip}</span>
                    }
                    placement='top'
                    arrow
                >
                    <IconButton
                        size='small'
                        sx={{p: '2px', color: 'text.disabled', flexShrink: 0}}
                    >
                        <InfoOutlined sx={{fontSize: 15}} />
                    </IconButton>
                </Tooltip>
            )}
        </Box>
        <Divider sx={{mb: 2}} />
        {children}
    </Box>
);

export default Section;
